import { Box, Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	title: string;
	rightAction?: ReactNode;
};

export const InspirationSectionHeader: FC<Props> = ({ title, rightAction }) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			pt={2.4}
			px={1.6}
			pb={0.8}
		>
			<Typography
				component="span"
				variant="overline"
				color={theme.palette.grey[500]}
			>
				{title}
			</Typography>
			{rightAction && <Box>{rightAction}</Box>}
		</Stack>
	);
};
